import { resolveModelVendorFromResolution } from "../cost/resolveModelVendor.js";
import type { ModelResolutionSuccess } from "../sync/modelNameResolver/types.js";
import type { InvokeModelResolutionInput, InvokeRouterConfigSlice } from "./types.js";

/**
 * Map catalog resolution to router `{ provider, model }`.
 */
export function mapResolutionToRouterConfig(
  resolution: ModelResolutionSuccess,
  input: InvokeModelResolutionInput,
  defaultProvider?: string,
): InvokeRouterConfigSlice {
  const ref = resolveModelVendorFromResolution(resolution, input.model, {
    asOpenRouter: resolution.routedViaOpenRouter,
  });
  if (ref) {
    return { provider: ref.provider, model: ref.model };
  }

  if (resolution.routedViaOpenRouter === true) {
    return {
      provider: "openrouter",
      model: resolution.modelId,
    };
  }

  let provider: string | undefined;
  let model: string;

  const slash = resolution.modelId.indexOf("/");
  if (slash > 0) {
    provider =
      resolution.record?.providerId ?? resolution.modelId.slice(0, slash);
    model = resolution.modelId.slice(slash + 1);
  } else {
    model = resolution.modelId;
    if (resolution.record?.providerId) {
      provider = resolution.record.providerId;
    }
  }

  if (!provider && defaultProvider) {
    provider = defaultProvider;
  }

  return { provider: provider ?? "", model };
}
